/**
 * Module de rendu des cercles de base
 */
export class CircleRenderer {
    /**
     * @param {CanvasRenderingContext2D} ctx - Contexte 2D du canvas
     * @param {Object} options - Options de configuration
     */
    constructor(ctx, options) {
        this.ctx = ctx;
        this.options = options;
    }

    /**
     * Dessine les cercles de base du thème astral - Style Art Déco
     * @param {number} cx - Coordonnée X du centre
     * @param {number} cy - Coordonnée Y du centre
     * @param {number} radius - Rayon du cercle extérieur
     */
    draw(cx, cy, radius) {
        const ctx = this.ctx;
        const innerRadius = radius * this.options.innerRadius;
        const zodiacInnerRadius = radius * (1 - this.options.zodiacWidth);

        // Cream ground, barely graded — the wheel sits on the page, it does not cut a
        // window into it.
        const bgGradient = ctx.createRadialGradient(cx, cy, 0, cx, cy, radius + this.options.margin);
        bgGradient.addColorStop(0, '#ffffff');     // surface
        bgGradient.addColorStop(0.7, '#fff9f3');   // surface-alt
        bgGradient.addColorStop(1, '#ffeede');     // surface-sunken

        ctx.fillStyle = bgGradient;
        ctx.beginPath();
        ctx.arc(cx, cy, radius + this.options.margin / 2, 0, Math.PI * 2);
        ctx.fill();

        // Outer ring — the theme's strong rule, not an accent: the structure is drawn in
        // line colours so the fox orange stays for what the reader is meant to look at.
        ctx.beginPath();
        ctx.arc(cx, cy, radius, 0, Math.PI * 2);
        ctx.strokeStyle = '#e6bfa4';  // line-strong
        ctx.lineWidth = 2.5;
        ctx.stroke();

        // Doubled outer ring
        ctx.beginPath();
        ctx.arc(cx, cy, radius - 3, 0, Math.PI * 2);
        ctx.strokeStyle = 'rgba(230, 191, 164, 0.55)';  // line-strong, softened
        ctx.lineWidth = 1;
        ctx.stroke();

        // Inner edge of the zodiac band
        ctx.beginPath();
        ctx.arc(cx, cy, zodiacInnerRadius, 0, Math.PI * 2);
        ctx.strokeStyle = '#e6bfa4';  // line-strong
        ctx.lineWidth = 1.5;
        ctx.stroke();

        // Aspect circle — dashed, quieter still
        ctx.beginPath();
        ctx.arc(cx, cy, innerRadius, 0, Math.PI * 2);
        ctx.strokeStyle = 'rgba(230, 191, 164, 0.75)';  // line-strong, softened
        ctx.setLineDash([3, 3]);
        ctx.lineWidth = 1;
        ctx.stroke();
        ctx.setLineDash([]);
    }
}